import { all, call, put, delay, debounce, takeLatest } from "redux-saga/effects";
import WhatsappService from "../../services/whatsapp.service";
import {
    getUserListFailed,
    getUserListSuccess,
    getUserMessagesFailed,
    getUserMessagesSuccess,
    sendMessageFailed,
    sendMessageSuccess,
    sendGenericTemplateMessageSuccess,
    sendGenericTemplateMessageFailed,
    getTemplatesSuccess,
    getTemplatesFailed,
    getTemplateStatusSuccess,
    getTemplateStatusFailed,
    getUserMessagesFrequentSuccess,
    setLastMessage
} from "./whatsappSlice";
import { showErrorToaster, showSuccessToaster } from "../../helpers/utils/toaster";

function* whatsappWatcher() {
    yield debounce(500, "whatsapp/getUserList", getUserListSaga);
    yield takeLatest("whatsapp/getUserMessagesFrequent", getUserMessagesFrequentSaga);
    yield takeLatest("whatsapp/getUserMessages", getUserMessagesSaga);
    yield takeLatest("whatsapp/sendMessage", sendMessageSaga);
    yield takeLatest("whatsapp/sendGenericTemplateMessage", sendGenericTemplateMessageSaga);
    yield takeLatest("whatsapp/getTemplates", getTemplatesSaga);
    yield takeLatest("whatsapp/getTemplateStatus", getTemplateStatusSaga);
}

function* getUserListSaga(action) {
    try {
        const response = yield call(WhatsappService.getUserList, action.payload);

        if (response.status) {
            yield put(getUserListSuccess(response.data));
        } else {
            yield put(getUserListFailed(response.message));
        }
    } catch (err) {
        console.log("Error: ", err);
    }
}

function* getUserMessagesFrequentSaga(action) {
    try {
        const response = yield call(WhatsappService.getUserMessages, action.payload);

        if (response.status) {
            yield put(getUserMessagesFrequentSuccess(response.data));
            yield delay(100);
            yield put(getUserMessagesSuccess(response.data));
            yield put(setLastMessage({ phone: `whatsapp:+${action.payload.phone}`, lastMessage: response.data.rows[response.data.rows.length - 1]?.body || "" }));
        } else {
            yield put(getUserMessagesFailed(response.message));
        }
    } catch (err) {
        console.log("Error: ", err);
    }
}

function* getUserMessagesSaga(action) {
    try {
        const response = yield call(WhatsappService.getUserMessages, action.payload);

        if (response.status) {
            yield put(getUserMessagesSuccess(response.data));
        } else {
            yield put(getUserMessagesFailed(response.message));
        }
    } catch (err) {
        console.log("Error: ", err);
    }
}

function* sendMessageSaga(action) {
    try {
        const response = yield call(WhatsappService.sendMessage, action.payload);

        if (response.status) {
            yield put(sendMessageSuccess());
        } else {
            yield put(sendMessageFailed());
            showErrorToaster(response.message);
        }
    } catch (err) {
        console.log("Error: ", err);
    }
}

function* sendGenericTemplateMessageSaga(action) {
    try {
        const response = yield call(WhatsappService.sendGenericTemplateMessage, action.payload);

        if (response.status) {
            yield put(sendGenericTemplateMessageSuccess());
        } else {
            yield put(sendGenericTemplateMessageFailed());
            showErrorToaster(response.message);
        }
    } catch (err) {
        console.log("Error: ", err);
        yield put(sendGenericTemplateMessageFailed());
    }
}

function* getTemplatesSaga(action) {
    try {
        const response = yield call(WhatsappService.getTemplates);

        if (response.status) {
            yield put(getTemplatesSuccess(response.data));
        } else {
            yield put(getTemplatesFailed(response.message));
        }
    } catch (err) {
        console.log("Error: ", err);
        yield put(getTemplatesFailed(err.message));
    }
}

function* getTemplateStatusSaga(action) {
    try {
        const response = yield call(WhatsappService.getTemplateStatus, action.payload.sid);

        if (response.status) {
            yield put(getTemplateStatusSuccess(response.data.status));
        } else {
            yield put(getTemplateStatusFailed(response.message));
        }
    } catch (err) {
        console.log("Error: ", err);
        yield put(getTemplateStatusFailed(err.message));
    }
}

export default function* whatsappSaga() {
    yield all([whatsappWatcher()]);
}
